module.exports = __webpack_public_path__ + "static/img/eredin_king.b3c9781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/eredin_king.png
// module id = ihEE
// module chunks = 0